module.exports = __webpack_public_path__ + "img/pickup_location.545a30a4.svg";